import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-loading',
    imports: [MatProgressSpinnerModule],
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoadingComponent {
  @Input() show = true;
  @Input() overlay = false;
  @Input() diameter = 56;
  @Input() ariaLabel = 'Loading';
  @Input() message?: string;
}
